/**
 * 首页运营接口
 * 
 * @author 张子超
 * @since 2018-04-04
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口



/**
 * 获取文化积分充值开关
    /customer/api/jifentong/isEnabled.json

    RequireLogin: true

    参数
    返回
    enabled: boolean -
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.isEnabled = function(okCb, failCb){
    var p = {
    }
    common.Api('/customer/api/jifentong/isEnabled.json', p, okCb, failCb)
}

/**
 * 文化积分直充商品列表
    /customer/api/jifentong/productList.json

    RequireLogin: true

    参数
    返回
    list: list[object] -
        faceValue: float - 面值
        pricePoint: integer - 销售积分
        productId: integer - 产品id
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.productList = function(okCb, failCb){
    var p = {
    }
    common.Api('/customer/api/jifentong/productList.json', p, okCb, failCb)
}

/**
 * 文化积分充值默认手机
    /customer/api/jifentong/defaultPhone.json

    RequireLogin: true

    参数
    返回
    phone: string? -
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.defaultPhone = function(okCb, failCb){
    var p = {
    }
    common.Api('/customer/api/jifentong/defaultPhone.json', p, okCb, failCb)
}

/**
 * 文化积分充值记录列表
    /customer/api/jifentong/recordList.json

    RequireLogin: true

    参数
    lastId: integer? - lastId
    limit: integer - limit
    返回
    hasMore: boolean -
    lastId: integer -
    records: list[object] -
        chargeStatus: integer - 充值状态
            0: WAITING
            1: CHARGING
            2: SUCCESS
            3: FAIL
        createTime: string - 创建时间
        faceValue: float - 面值
        orderno: string - 订单号
        phone: string - 充值号码
        pricePoint: integer - 消耗积分
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.recordList = function(lastId, okCb, failCb){
    const limit = 10;
    var p = {
        lastId, limit
    }
    common.Api('/customer/api/jifentong/recordList.json', p, okCb, failCb)
}

/**
 * 文化积分充值记录详情
    /customer/api/jifentong/recordDetail.json

    RequireLogin: true

    参数
    orderno: string - orderno 订单号
    返回
    record: object -
        chargeStatus: integer - 充值状态
            0: WAITING
            1: CHARGING
            2: SUCCESS
            3: FAIL
        createTime: string - 创建时间
        faceValue: float - 面值
        orderno: string - 订单号
        phone: string - 充值号码
        pricePoint: integer - 消耗积分
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.recordDetail = function(orderno, okCb, failCb){
    var p = {
        orderno
    }
    common.Api('/customer/api/jifentong/recordDetail.json', p, okCb, failCb)
}

/**
 * 文化积分充值
    /customer/api/jifentong/charge.json

    RequireLogin: true

    参数
    phone: string - 手机号
    pricePoint: integer - 商品价格 (积分)，回传用于校验
    productId: integer - 产品id
    返回
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.charge = function(phone, pricePoint, productId, okCb, failCb){
    var p = {
        phone, pricePoint, productId
    }
    common.Api('/customer/api/jifentong/charge.json', p, okCb, failCb)
}

export default ApiList;


// WEBPACK FOOTER //
// ./src/api/jifentong-api.js